import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Nick
 * id AF2B1665-3D54-4017-BF7C-AE03A7C6AA52
 * name not-equal-variant
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/not-equal-variant.svg
 * tags
 * - Math 
 */
export const NotEqualVariantIcon = createSvgIcon(<><path d="M14.08,4.61L15.92,5.4L14.8,8H19V10H13.95L12.23,14H19V16H11.38L9.92,19.4L8.08,18.61L9.2,16H5V14H10.06L11.77,10H5V8H12.63L14.08,4.61Z" /></>, 'NotEqualVariantIcon');
export default NotEqualVariantIcon